<template>
  <!-- loading i axios servisinde kullanmak için isSgow u store a alsak proje içine girmiş olacak istediğimiz bir durum değil.
  js te bunu nasıl çalıştırırız karar verilmesi gerek -->
  <div class="loader-body" v-if="isShow">
    <span class="loader-css"></span>
  </div>
</template>
<script>
import { warn } from 'vue';

export default {
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    toggle() {
      this.isShow != this.isShow;
    },
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    }
  },

}
</script>
<style scoped>
.loader-body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(63, 68, 77, 0.7);
  z-index: 9999;
}

.loader-css {
  width: 48px;
  height: 48px;
  border: 5px solid #240c90;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>